import cls from "classnames"

import styles from "./index.module.less"

interface CloseProps {
    className?: string
    style?: React.CSSProperties
    onClick?: () => void
}
const Close: React.FC<CloseProps> = (props) => {
    const { className, style, onClick } = props

    return (
        <button
            className={cls(styles.close, className)}
            style={style}
            onClick={onClick}
        />
    )
}

export default Close
